
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Modal from "../../../styled-base/modal";
import ModalHeader from "../../../components/modals/commons/modalHeader";
import ModalFooter from "../../../components/modals/commons/modalFooter";
import "./orgResultsDialogs.scss"
import SampleMessageDialog from "./SampleMessage.dialog";
import { withTranslation } from "react-i18next";
import OrgResultsServices from "../../services/orgResults.services";

const orgResultsServices = new OrgResultsServices();
class KudosPingDialog extends Component< any, any > {
    private popupScrollContainer: any;
    constructor(props: any){
        super(props);
        this.state = {
            showLoader: false,
        }
        this.popupScrollContainer = React.createRef();
    }
    
    componentDidMount(): void {
        if(this.props.modalData.type){ // event track on 
            let ref ;
            if(this.props.modalData.type === "top") {
                ref = 'RESULTS_ANALYTICS_KUDOS';
            } else if (this.props.modalData.type === "bottom" || this.props.modalData.type === "zero"){
                ref = 'RESULTS_ANALYTICS_NUDGE';
            } else if (this.props.modalData.type === "hundred"){
                ref = 'RESULTS_ANALYTICS_MESSAGE';
            }
            if(ref) {
                orgResultsServices.resultAnalyticsEvents({
                ref : ref,
                teamId: this.props.forData.teamId,
                timeFrame: this.props.timeFrame })
            }
        }
    }

    nudgeAll = () => {
        let params: any = {
            type: this.props.modalData.type,
            ...this.props.forData,
            subject: document.querySelector("#sub").innerHTML,
            message: document.querySelector("#message").innerHTML,
            timeFrame: this.props.timeFrame
        }
       
        this.props.nudgeAll(params);
        showLoaderWidget(document.querySelector("#content"));
        this.props.closePopup();
    }

    viewSample = (e) => {
        ReactDOM.render(
            <SampleMessageDialog
              type={this.props.modalData.type}
              closePopup = {this.closeSampleModal}
            />,
            document.getElementById("sample-message")
          ); 
    }

    closeSampleModal = () => {
        ReactDOM.unmountComponentAtNode(document.getElementById("sample-message"));
      }

    render(){
    const { modalData, t } = this.props;

    return (
        <>
            <Modal 
                //isFixed={true}
                width={480}
                //style={{width: "550px !important", transform: "translate(14%, calc(50% - 275px)) !important"}}
                // minHeight="250px"
                // maxHeight="550px"
                // height="auto"
                id="kudosPingDialog"
                //position={{ x: '14% !important', y: 'calc(50% - 275px) !important' }}
                // style={{left: "calc(50% - 275px) !important"}}
                
                transform_property={true}
                transform_property_lm={false}>
                <div className={`wbmodal `} style={{width: "480px !important", maxHeight:"450px"}}>
                    <ModalHeader 
                        title = {modalData.title}
                        closePopup = {()=>this.props.closePopup(modalData)}
                    />
                    <div className="wbmodal-content" style={{maxHeight:"300px", overflowY:"auto"}} ref={this.popupScrollContainer}>
                        <div className={`${modalData.type}`} >
                            <div className="info-text">
                                {/* {`Message will be sent to all ${modalData.members} member${modalData.members > 1 ? "s" : ""} of ${modalData.typeFullName}`} */}
                                {modalData.info}
                            </div>
                            <div className="field">
                                <label>
                                {t('Email subject line')}
                                </label>
                                <div className="textFieldWrapperDiv">
                                    <div contentEditable="true" id="sub" className="text-field badgeAutoSuggest" data-placeholder="Type a person's name, multiple peoples' names, or a team to badge them">
                                        {modalData.subject}
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <div style={{display: "flex", justifyContent:"space-between"}}>
                                    <label>
                                    {t('Include a custom message')}:
                                    </label>
                                    <p className="sample-link" style={{marginBottom: 0}} onClick={this.viewSample}>
                                        {t('View sample')}
                                    </p>
                                </div>
                                
                                <div className="textFieldWrapperDiv">
                                    <div contentEditable="true" id="message" className="text-field badgeAutoSuggest message"  >
                                    {modalData.message}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalFooter
                        addItem = {this.nudgeAll}
                        buttonLabel = "Send"
                        closePopup = {()=>this.props.closePopup(modalData)}
                        itemsLength = {2}
                    />
                </div>
            </Modal>
            <div id="sample-message"></div>
        </>  
        );
    }
}

export default withTranslation()(KudosPingDialog);
